import './App.css';
import { useEffect, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './Pages/Home';
import styled from 'styled-components';
import BkImg from './assets/img/bkgr/bkimg.webp';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTopButton from './components/ScrollToTopButton';
import CookieBanner from './components/CookieBanner';
import Privacy from './Pages/Privacy';
import ScrollToTop from './components/ScrollToTop';
import Catalog from './Pages/Catalog';
import Blog from './Pages/Blog';
import AboutUs from './Pages/AboutUs';
import Contacts from './Pages/Contacts';
import Terms from './Pages/Terms';
import MapSite from './Pages/MapSite';
import UserPage from './Pages/UserPage';
import api from './api/axiosConfig';
import Reviews from './Pages/Reviews';
import PublicUserPage from './Pages/PublicUserPage';
import PayPalResult from './Pages/PayPalResult';
import AutoInstall from './Pages/AutoInstall';
const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;

  display: flex;
  flex-direction: column;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  margin: 0;

  /* общий "гаттер" для всех секций */
  padding-inline: clamp(12px, 3.5vw, 32px);

  /* iPhone safe-area */
  padding-left: max(clamp(12px, 3.5vw, 32px), env(safe-area-inset-left));
  padding-right: max(clamp(12px, 3.5vw, 32px), env(safe-area-inset-right));
`;

const Main = styled.main`
  width: 100%;
`;

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [homeData, setHomeData] = useState(null);

  useEffect(() => {
    api
      .get('/homepage/')
      .then((res) => setHomeData(res.data))
      .catch(console.error);
  }, []);

  // useEffect(() => {
  //   api
  //     .get('/api/homepage/')
  //     .then((res) => {
  //       console.log('HOMEDATA FROM API:', res.data);
  //       setHomeData(res.data);
  //     })
  //     .catch((err) => {
  //       console.error('API ERROR:', err);
  //     });
  // }, []);

  return (
    <Container style={{ backgroundImage: `url(${BkImg})` }}>
      <Header onMobileMenuChange={setMenuOpen} homeData={homeData} />
      <ScrollToTop menuOpen={menuOpen} />
      <Main>
        <Routes>
          <Route path="/" element={<Home homeData={homeData} />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/catalog" element={<Catalog />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/map-site" element={<MapSite />} />
          <Route path="/me" element={<UserPage />} />
          <Route path="/autoinstall/:orderId" element={<AutoInstall />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/u/:idSlug" element={<PublicUserPage />} />
          <Route path="/payment/paypal/return" element={<PayPalResult />} />
          <Route path="/payment/paypal/cancel" element={<PayPalResult cancelled />} />
        </Routes>
      </Main>

      <Footer />
      <ScrollToTopButton />
      <CookieBanner />
    </Container>
  );
}

export default App;
